export const NAV_ROUTE: Array<any> = [
    {
        routeLink: '/embaded-soft',
        routeModule: '',
        routeTitle: 'Embaded Soft',
        routeIcon: 'bw_download',
        divider: '0',
        hidden: false,
        submenu: []
    }
];
